import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { startOfDay, endOfDay, addDays } from 'date-fns';

// components
import Grid from '@material-ui/core/Grid';
import Typography from 'components/shared/Typography';
import Calendar from './Calendar';
import { SPACING_HALF, SPACING_LEAST } from 'constants/spacing';
import LoadingButton from 'components/shared/LoadingButton';
import { getWorkDaysInStorage, getWorkHoursInStorage } from 'lib/Storage';

// hooks

// utils

//assets
import selectDateTimeImage from 'assets/images/customer/datetime.png';
import { useAllEventsByCustomer } from 'hooks/event';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    width: '100%',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    bottom: '0',
    position: 'relative',
  },
  selectionWrapper: {
    marginTop: theme.spacing(SPACING_HALF),
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    fontSize: theme.typography.pxToRem(20),
    paddingLeft: 0,
    paddingRight: 0,
    '&:disabled': {
      color: '#959595',
    },
  },
  backButton: {
    backgroundColor: 'transparent',
    color: '#878787',
    border: '1px solid',
    borderColor: '#878787',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#333',
      borderColor: '#333',
    },
  },
  wholepage: {
    width: '100vw',
    height: '100vh',
    backgroundColor: '#e5e5e5',
  },
  mainContainer: {
    backgroundColor: '#f5f5f5',
    position: 'relative',
    top: '15%',
    padding: '0px',

    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#e5e5e5',
      top: '0',
    },
  },

  checkbox: {
    position: 'relative',
    top: '35%',
    width: '50%',
  },
  singleLineText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function SelectDateTime({ setSelectedTime, selectedService, nextStep, prevStep }) {
  const classes = useStyles();

  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);

  const [isSettingSelectedDate, setIsSettingSelectedDate] = useState(false);

  const [possibleAppointments, setPossibleAppointments] = useState([]);

  const { mutate, isLoading } = useAllEventsByCustomer();

  const onSubmitNext = (e) => {
    console.log('nwx!1:', e);
    nextStep();
  };

  const onSubmitPrev = (e) => {
    console.log('back!!!:', e);
    prevStep();
  };

  const dateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: 'numeric',
    hour12: false,
  };

  useEffect(() => {
    const from = startOfDay(currentDate); // Set the start of the week based on "fa" locale (Saturday)
    const to = endOfDay(currentDate); // Set the end of the week based on "fa" locale (Friday)

    mutate(
      { serviceId: selectedService?._id, from, to },
      {
        onSuccess: (data) => {
          if (data?.status === 'OK') {
            console.log('OK_events');
            let eventArray = data?.events || [];

            console.log("selectedservice is:",selectedService)
            let selectedBranch = selectedService?.division?.branch;
            let workDays = getWorkDaysInStorage()
            let workHours = getWorkHoursInStorage()

            workDays = workDays[selectedBranch]
            workHours = workHours[selectedBranch]

            const interval = (selectedService?.duration || 60) * 60 * 1000; // 1 hour in milliseconds
            const startTime = new Date(from); // Start time for appointments
            startTime.setHours(workHours.start||10, 0, 0, 0); // Set the desired start time (10:00:00)
            const endTime = new Date(to); // End time for appointments
            endTime.setHours(workHours.end||18, 0, 0, 0); // Set the desired end time (20:00:00)

            const possibleAppointments = [];
            let currentTime = new Date(startTime);
            if(! workDays[currentTime.getDay()]){
              setPossibleAppointments(possibleAppointments);
              return;
            }

            while (currentTime < new Date()) {
              possibleAppointments.push({
                startDate: new Date(currentTime),
                endDate: new Date(currentTime.getTime() + interval),
                selectable: false,
              });
              currentTime = new Date(currentTime.getTime() + interval);
              if (currentTime.getHours() >= 20) {
                currentTime.setHours(10, 0, 0, 0);
                currentTime = addDays(currentTime, 1);
              }
            }
            while (currentTime < endTime) {
              let hasIntersectingEvent = false;

              // Check if there is any intersecting event at the current time
              eventArray.forEach((event) => {
                const eventStartTime = new Date(event.start);
                const eventEndTime = new Date(event.end);

                // Check if the event falls entirely within the current time slot
                if (
                  eventStartTime >= currentTime &&
                  eventEndTime.getTime() <= currentTime.getTime() + interval
                ) {
                  hasIntersectingEvent = true;
                  return;
                }

                // Check if the event overlaps with the current time slot
                if (
                  eventStartTime.getTime() < currentTime.getTime() + interval &&
                  eventEndTime > currentTime
                ) {
                  hasIntersectingEvent = true;
                  return;
                }
              });

              // If no intersecting event found, add the current time as a possible appointment
              // if (!hasIntersectingEvent) {
              //   possibleAppointments.push({
              //     startDate: new Date(currentTime),
              //     endDate: new Date(currentTime.getTime() + interval),

              //   });
              // }
              possibleAppointments.push({
                startDate: new Date(currentTime),
                endDate: new Date(currentTime.getTime() + interval),
                selectable: !hasIntersectingEvent,
              });

              // Move to the next interval
              currentTime = new Date(currentTime.getTime() + interval);
              if (currentTime.getHours() >= 20) {
                currentTime.setHours(10, 0, 0, 0);
                currentTime = addDays(currentTime, 1);
              }
            }
            console.log(possibleAppointments);
            // let tempList = data.services.map((service) =>
            //   service.title.split('-')[0].trim()
            // );
            // let uniqueServiceList = _.uniq(tempList);
            // setServices(data?.services.map((service)=>({...service, title:service.title.split("/")[0].trim()})));
            // setServices(uniqueServiceList);
            setPossibleAppointments(possibleAppointments);
          }
        },
      }
    );
  }, [mutate, currentDate, selectedService, setPossibleAppointments]);

  return (
    <Grid container spacing={0} style={{ height: '100%', overflowX: 'hide' }}>
      <Grid item xs={6} className={classes.leftPanel}>
        <img src={selectDateTimeImage} alt="left" height={'70%'} />
      </Grid>
      <Grid item xs={12} md={6} style={{ height: '100%', padding: '3%', overflowY: 'auto' }}>
        <Grid container spacing={0} style={{ alignContent: 'space-between', height: '100%' }}>
          <Grid item xs={12} style={{ height: '85%', overflowY: 'auto' }}>
            <Grid container spacing={SPACING_LEAST}>
              <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Typography variant="h1">تاریخ و ساعت</Typography>
              </Grid>
              <Grid item xs={12} style={{ alignContent: 'center', textAlign: 'center' }}>
                <Typography variant="h5" style={{ color: '#838383' }}>
                  لطفا زمان مورد نظر خود را انتخاب نمایید
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  alignContent: 'center',
                  textAlign: 'center',
                  marginTop: '3%',
                  height: '60%',
                }}
              >
                <Grid container spacing={SPACING_LEAST}>
                  <Grid item xs={12}>
                    {/* <Calendar events={arrayUniqueKey(events, 'id')} handleEventClick={setEventModal} /> */}
                    <Calendar
                      selectEventHandler={setSelectedDate}
                      events={possibleAppointments}
                      setCurrentDate={setCurrentDate}
                      currentDate={currentDate}
                      selectedDate={selectedDate}
                      isLoading={isLoading}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={SPACING_HALF} style={{ bottom: 0, position: 'relative' }}>
              <Grid
                item
                xs={6}
                style={{ paddingRight: '5%' }}
                className={classes.selectionWrapper}
              >
                <Typography>زمان انتخابی:</Typography>
              </Grid>
              <Grid item xs={6} className={classes.selectionWrapper}>
                <Typography>
                  {selectedDate?.startDate?.toLocaleDateString('fa-IR', dateOptions) ||
                    'در انتظار انتخاب'}
                </Typography>
              </Grid>

              <Grid item xs={6} className={classes.buttonWraper}>
                <LoadingButton
                  className={clsx(classes.largeLabel)}
                  type="submit"
                  // size="small"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={!selectedDate}
                  onClick={() => {
                    setSelectedTime(selectedDate);
                    onSubmitNext();
                  }}
                  loading={isSettingSelectedDate}
                >
                  مرحله بعد
                </LoadingButton>
              </Grid>
              <Grid item xs={6} className={classes.buttonWraper}>
                <LoadingButton
                  className={clsx(classes.largeLabel, classes.backButton)}
                  type="submit"
                  // size="small"
                  fullWidth
                  variant="contained"
                  // color="default"
                  // disabled={selectedService === ''}
                  onClick={onSubmitPrev}
                >
                  بازگشت
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SelectDateTime;
